export default __webpack_public_path__ + "static/media/178.c31993fa.png";